import { Configuration, PopupRequest } from '@azure/msal-browser';

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '52a44c32-0642-4e37-90a0-90bb2ab64806',
    authority: 'https://login.microsoftonline.com/common', // Use 'common' for multi-tenant
    // redirectUri: window.location.origin + '/auth/microsoft/callback',
        // redirectUri: 'https://kpmgdev.kresus.com/auth/microsoft/callback',
        redirectUri: 'https://kpmg-sc.kresus.com/auth/microsoft/callback',

  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

// Login request configuration
export const loginRequest: PopupRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
  prompt: 'select_account', // Force account selection
};

// Silent token request configuration
export const silentRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
  account: null as any, // Will be set dynamically
};

export default msalConfig;
